import * as angular from 'angular';
import * as _ from 'lodash';
import ComponentController from '../../../common/components/component-controller';
const templateUrl = require('./reportSchedules.html');

class ReportSchedulesController extends ComponentController {
  reportSchedules: any[];
  canCreate: boolean;

  constructor(private $state: any, private ReportScheduleService: any, private AuthService: any) {
    super();
  }

  $onInit() {
    this.canCreate = this.AuthService.hasPermission('EpxReportSchedule', 'create');
    this.reportSchedules = _.orderBy(this.reportSchedules, 'epxUnit.name');
  }
}

angular.module('ciApp').component('reportSchedules', {
  templateUrl: templateUrl,
  bindings: {
    reportSchedules: '<'
  },
  controller: ['$state', 'ReportScheduleService', 'AuthService', ReportSchedulesController]
});



// WEBPACK FOOTER //
// ./app/admin/report-schedules/reportSchedules.component.ts